import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'

export const getKeyObjectivesFYears = (keyObjectives: IKeyObjective[]) =>
  [
    ...new Set(
      keyObjectives
        .map(({ fYear }) => fYear)
        .filter((fYear): fYear is number => typeof fYear === 'number')
    ),
  ].sort((a, b) => b - a)
